module.exports = __webpack_public_path__ + "static/media/horizon.5fb1056c539c8a5fd2ea22f239f18bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/horizon.jpg
// module id = 2506
// module chunks = 1